// extracted by mini-css-extract-plugin
export default {"employeeBlock":"ClientBlock_employeeBlock__jEn5i","employeePhone":"ClientBlock_employeePhone__YZxpr","employeeDuration":"ClientBlock_employeeDuration__-es0U"};